import { ProgressMetadataType } from "types/ReadingJournalType";
import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import icon from "icons/regular/book-circle-arrow-up.svg";
import { ReadingJournalEventProps } from "./types";

export default function ProgressUpdated({ journal }: ReadingJournalEventProps) {
  const metadata = journal.metadata as ProgressMetadataType;
  return (
    <Text variant="secondary" className="flex flex-row items-center gap-2">
      <Icon icon={icon} />
      <span>
        Updated progress from <b>{metadata.progress_was || 0}%</b> →{" "}
        <b>{metadata.progress}%</b>
      </span>
    </Text>
  );
}
